import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import chooseImg from "../assets/choose.png"; 
import StepsTimeline from "./Stepline";

export default function WhyChooseUs() {
  const points = [
    "Safe & Reliable",
    "Quick Approvals",
    "Flexible Loan Options",
    "Transparent Process",
    "Secure & Confidential",
    "Dedicated Support",
  ];

  return (
    <div style={styles.section}>
      <div className=" py-5">
        <h2 className="text-center fw-bold mb-5">Why Choose us</h2>

        <div className="row align-items-center justify-content-center">
          {/* Left Side Image */}
          <div className="col-md-5 text-center mb-4 mb-md-0">
            <div style={styles.imageWrapper}>
              <div style={styles.orangeBlockLeft}></div>
              <div style={styles.orangeBlockRight}></div>
              <img
                src={chooseImg}
                alt="Why Choose Us"
                style={styles.image}
                className="img-fluid"
              />
            </div>
          </div>

          {/* Right Side Text */}
          <div className="col-md-6">
            <p style={styles.text}>
              We are a new-age financial service provider committed to making
              loans<br/> simple, transparent, and accessible for everyone. Our goal
              is to remove the<br/> complexity from traditional lending by offering
              quick approvals, fair interest <br/> rates, and flexible loan options.
            </p>
            <p style={styles.text}>
              With a strong focus on customer-first support and secure
              processes, we aim <br/> to build long-term trust and lasting
              relationships with every customer <br/> we serve.
            </p>
          </div>
        </div>

        <StepsTimeline points={points} />
      </div>
    </div>
  );
}

const styles = {
  section: {
    backgroundColor: "#fff",
  },
  imageWrapper: {
    position: "relative",
    display: "inline-block",
  },
  orangeBlockLeft: {
    position: "absolute",
    top: "30px",
    left: "0",
    width: "160px",
    height: "220px",
    backgroundColor: "#f17c58",
    borderRadius: "15px",
    zIndex: 1,
  },
  orangeBlockRight: {
    position: "absolute",
    bottom: "20px",
    right: "0",
    width: "160px",
    height: "220px",
    backgroundColor: "#f17c58",
    borderRadius: "15px",
    zIndex: 1,
  },
  image: {
    position: "relative",
    zIndex: 2,
    borderRadius: "20px",
    maxHeight: "400px",
    objectFit: "cover",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.7",
    color: "#555",
    marginBottom: "15px",
  },
  
  
};
